<template>
  <DataList
    title="Продукти"
    resource="products"
    :columns="columns"
    :get-items-fn="getProducts"
    search-label="Пошук за назвою або артикулем продукту"
  >
    <template v-slot:action-buttons>
      <DownloadFile
        :location="`products/rpc/export-to-excel`"
        filename="Продукти"
        extension="xlsx"
        tooltip="Завантажити у форматі Excel"
      />
    </template>
  </DataList>
</template>

<script>
import * as productsApi from "../../../backend/productsApi.js";
import DownloadFile from "../../../components/DowloadFile.vue";

export default {
  components: { DownloadFile },
  data: () => ({
    columns: [
      { title: "id", name: "id" },
      { title: "Найменування", name: "title", rowType: "wide" },
      { title: "Артикул", name: "article" },
      { title: "Вартість, грн без ПДВ", name: "amount" },
      { title: "Категорія", name: "category", dataPath: "category.title" },
      { title: "Примітки", name: "comments", cropLimit: 50 },
    ],
  }),
  methods: {
    getProducts(...args) {
      return productsApi.getProducts(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>
